var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31975 2.15533C7.67965 2.08883 6.07883 2.55522 4.81542 3.45154C3.55377 4.34661 2.72358 5.60106 2.44705 6.96722C2.17104 8.33084 2.45844 9.74401 3.27377 10.9499C3.41888 11.1645 3.45592 11.4344 3.374 11.6802L2.75124 13.5485L5.24334 13.0182C5.42475 12.9796 5.61386 13.0026 5.78071 13.0837C7.20917 13.7771 8.88144 13.9889 10.4813 13.672C12.081 13.3551 13.4758 12.5364 14.4186 11.3925C15.3589 10.2518 15.7891 8.86383 15.6541 7.48537C15.519 6.10559 14.823 4.79493 13.6637 3.80614C12.5023 2.81552 10.9598 2.22183 9.31975 2.15533ZM3.85105 2.09221C5.42882 0.972871 7.39597 0.409293 9.38727 0.490032C11.3786 0.570771 13.2838 1.29149 14.7453 2.53809C16.209 3.78651 17.1327 5.4836 17.3129 7.32289C17.4931 9.16351 16.9128 10.9869 15.7047 12.4526C14.4991 13.9153 12.7536 14.9209 10.8052 15.3069C8.954 15.6736 7.01789 15.4621 5.3181 14.7063L1.67352 15.4817C1.38118 15.5439 1.07792 15.4448 0.878753 15.222C0.679584 14.9991 0.615012 14.6867 0.709527 14.4031L1.66769 11.5286C0.781866 10.0416 0.473238 8.31766 0.813509 6.63658C1.18069 4.82255 2.27152 3.2128 3.85105 2.09221Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0001 7.16665C9.46033 7.16665 9.83343 7.53974 9.83343 7.99998V8.00831C9.83343 8.46855 9.46033 8.84165 9.0001 8.84165C8.53986 8.84165 8.16676 8.46855 8.16676 8.00831V7.99998C8.16676 7.53974 8.53986 7.16665 9.0001 7.16665Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66676 7.16665C6.127 7.16665 6.5001 7.53974 6.5001 7.99998V8.00831C6.5001 8.46855 6.127 8.84165 5.66676 8.84165C5.20653 8.84165 4.83343 8.46855 4.83343 8.00831V7.99998C4.83343 7.53974 5.20653 7.16665 5.66676 7.16665Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3334 7.16665C12.7937 7.16665 13.1668 7.53974 13.1668 7.99998V8.00831C13.1668 8.46855 12.7937 8.84165 12.3334 8.84165C11.8732 8.84165 11.5001 8.46855 11.5001 8.00831V7.99998C11.5001 7.53974 11.8732 7.16665 12.3334 7.16665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.2b627717560e8652b2be17deb1efb98e.svg";
export { ForwardRef as ReactComponent };